var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-tooltip-btn',{attrs:{"href":"https://discord.gg/HJXwxMy","icon":"$mdiDiscord","path":"discord","rel":"noopener","target":"_blank"},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }